/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.HeartbeatMsg = (function() {

    /**
     * Properties of a HeartbeatMsg.
     * @exports IHeartbeatMsg
     * @interface IHeartbeatMsg
     * @property {string|null} [guid] HeartbeatMsg guid
     * @property {number|null} [version] HeartbeatMsg version
     * @property {HeartbeatMsg.HeartbeatType|null} [heartbeatType] HeartbeatMsg heartbeatType
     * @property {string|null} [fromGuid] HeartbeatMsg fromGuid
     */

    /**
     * Constructs a new HeartbeatMsg.
     * @exports HeartbeatMsg
     * @classdesc Represents a HeartbeatMsg.
     * @implements IHeartbeatMsg
     * @constructor
     * @param {IHeartbeatMsg=} [properties] Properties to set
     */
    function HeartbeatMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * HeartbeatMsg guid.
     * @member {string} guid
     * @memberof HeartbeatMsg
     * @instance
     */
    HeartbeatMsg.prototype.guid = "";

    /**
     * HeartbeatMsg version.
     * @member {number} version
     * @memberof HeartbeatMsg
     * @instance
     */
    HeartbeatMsg.prototype.version = 0;

    /**
     * HeartbeatMsg heartbeatType.
     * @member {HeartbeatMsg.HeartbeatType} heartbeatType
     * @memberof HeartbeatMsg
     * @instance
     */
    HeartbeatMsg.prototype.heartbeatType = 0;

    /**
     * HeartbeatMsg fromGuid.
     * @member {string} fromGuid
     * @memberof HeartbeatMsg
     * @instance
     */
    HeartbeatMsg.prototype.fromGuid = "";

    /**
     * Creates a new HeartbeatMsg instance using the specified properties.
     * @function create
     * @memberof HeartbeatMsg
     * @static
     * @param {IHeartbeatMsg=} [properties] Properties to set
     * @returns {HeartbeatMsg} HeartbeatMsg instance
     */
    HeartbeatMsg.create = function create(properties) {
        return new HeartbeatMsg(properties);
    };

    /**
     * Encodes the specified HeartbeatMsg message. Does not implicitly {@link HeartbeatMsg.verify|verify} messages.
     * @function encode
     * @memberof HeartbeatMsg
     * @static
     * @param {IHeartbeatMsg} message HeartbeatMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HeartbeatMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.heartbeatType != null && message.hasOwnProperty("heartbeatType"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.heartbeatType);
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fromGuid);
        return writer;
    };

    /**
     * Encodes the specified HeartbeatMsg message, length delimited. Does not implicitly {@link HeartbeatMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof HeartbeatMsg
     * @static
     * @param {IHeartbeatMsg} message HeartbeatMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HeartbeatMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a HeartbeatMsg message from the specified reader or buffer.
     * @function decode
     * @memberof HeartbeatMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {HeartbeatMsg} HeartbeatMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HeartbeatMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HeartbeatMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.version = reader.int32();
                break;
            case 3:
                message.heartbeatType = reader.int32();
                break;
            case 4:
                message.fromGuid = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a HeartbeatMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof HeartbeatMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {HeartbeatMsg} HeartbeatMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HeartbeatMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a HeartbeatMsg message.
     * @function verify
     * @memberof HeartbeatMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    HeartbeatMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.heartbeatType != null && message.hasOwnProperty("heartbeatType"))
            switch (message.heartbeatType) {
            default:
                return "heartbeatType: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        return null;
    };

    /**
     * Creates a HeartbeatMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof HeartbeatMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {HeartbeatMsg} HeartbeatMsg
     */
    HeartbeatMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.HeartbeatMsg)
            return object;
        var message = new $root.HeartbeatMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        switch (object.heartbeatType) {
        case "UNKNOWN":
        case 0:
            message.heartbeatType = 0;
            break;
        case "KEEPALIVE":
        case 1:
            message.heartbeatType = 1;
            break;
        }
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        return message;
    };

    /**
     * Creates a plain object from a HeartbeatMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof HeartbeatMsg
     * @static
     * @param {HeartbeatMsg} message HeartbeatMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    HeartbeatMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.heartbeatType = options.enums === String ? "UNKNOWN" : 0;
            object.fromGuid = "";
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.heartbeatType != null && message.hasOwnProperty("heartbeatType"))
            object.heartbeatType = options.enums === String ? $root.HeartbeatMsg.HeartbeatType[message.heartbeatType] : message.heartbeatType;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        return object;
    };

    /**
     * Converts this HeartbeatMsg to JSON.
     * @function toJSON
     * @memberof HeartbeatMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    HeartbeatMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * HeartbeatType enum.
     * @name HeartbeatMsg.HeartbeatType
     * @enum {string}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} KEEPALIVE=1 KEEPALIVE value
     */
    HeartbeatMsg.HeartbeatType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "KEEPALIVE"] = 1;
        return values;
    })();

    return HeartbeatMsg;
})();

module.exports = $root;
